import { Component, Input, OnChanges, OnInit } from '@angular/core';

@Component({
  selector: 'app-profile-photo',
  templateUrl: './profile-photo.component.html',
  styleUrls: ['./profile-photo.component.scss']
})
export class ProfilePhotoComponent implements OnInit, OnChanges {

  @Input() photoUrl: string = '';
  @Input() firstName: string = '';
  @Input() lastName: string = '';
  @Input() fullName: string = '';
  @Input() size: string = 'normal';
  @Input() patient;
  @Input() practitioner;

  photo: string = '';
  initials: string = '';
  name: string = '';

  constructor() { }

  ngOnInit() {
    if (this.photoUrl) {
      this.photo = this.photoUrl;
    }
    this.setInitials();
  }

  ngOnChanges() {
    this.photo = '';
    this.initials = '';

    this.setInitials();
    if (this.photoUrl) {
      this.photo = this.photoUrl;
    }
  }

  setInitials(): void {
    if (this.fullName !== '') {
      this.initials = this.fullName.split(' ')[0].substring(0, 1).toUpperCase() + this.fullName.split(' ')[this.fullName.split(' ').length - 1].substring(0, 1).toUpperCase();
      this.name = this.fullName;
    } else {
      this.initials = this.firstName.substring(0, 1).toUpperCase() + this.lastName.substring(0, 1).toUpperCase();
      this.name = `${this.firstName} ${this.lastName}`;
    }
  }
}
